<template>
  <div>
    <!-- Header -->
    <div class="relative flex justify-center items-center">
      <div class="absolute z-30 text-white px-6">
        <h1 class="text-4xl md:text-5xl leading-[50px] md:leading-[60px] font-serif text-center">{{ $t('services.psychological-services.title') }}</h1>
      </div>
      <div class="absolute z-20 inset-0 bg-black opacity-40"></div>
      <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" class="object-cover min-h-[400px] w-full md:aspect-[3]"
        src="/images/services/psychological-services-hero.jpg" :alt="$t('services.psychological-services.title')" />
    </div>

    <!-- Main Content -->
    <div class="container mx-auto px-6 py-12">
      <p class="text-sm md:text-base text-gray-600 mb-12 max-w-4xl">
        {{ $t('services.psychological-services.description') }}
      </p>

      <div class="grid md:grid-cols-2 gap-12">
        <div class="bg-white rounded-lg p-8 shadow-lg">
          <h3 class="text-xl md:text-2xl font-serif mb-6">{{ $t('services.psychological-services.individual.title') }}
          </h3>
          <ul class="space-y-3 text-sm md:text-base">
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-red-600 shrink-0" />
              {{ $t('services.psychological-services.individual.support') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-red-600 shrink-0" />
              {{ $t('services.psychological-services.individual.counseling') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-red-600 shrink-0" />
              {{ $t('services.psychological-services.individual.guidance') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-red-600 shrink-0" />
              {{ $t('services.psychological-services.individual.stress') }}
            </li>
          </ul>
          <!-- <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" src="/images/services/psychological-services-individual.jpg"
            :alt="$t('services.psychological-services.individual.title')"
            class="mt-8 rounded-lg w-full h-64 object-cover" /> -->
        </div>

        <div class="bg-white rounded-lg p-8 shadow-lg">
          <h3 class="text-xl md:text-2xl font-serif mb-6">{{ $t('services.psychological-services.group.title') }}</h3>
          <ul class="space-y-3 text-sm md:text-base">
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-red-600 shrink-0" />
              {{ $t('services.psychological-services.group.support') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-red-600 shrink-0" />
              {{ $t('services.psychological-services.group.workshops') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-red-600 shrink-0" />
              {{ $t('services.psychological-services.group.mindfulness') }}
            </li>
            <li class="flex items-center gap-2">
              <Icon name="mdi:check-circle" class="text-red-600 shrink-0" />
              {{ $t('services.psychological-services.group.emotional') }}
            </li>
          </ul>
          <!-- <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" src="/images/services/psychological-services-group.jpg"
            :alt="$t('services.psychological-services.group.title')" class="mt-8 rounded-lg w-full h-64 object-cover" /> -->
        </div>
      </div>

      <div class="mt-12 p-8 shadow-lg">
        <h2 class="text-xl md:text-2xl font-serif mb-8">{{ $t('services.psychological-services.parenting.title') }}</h2>
        <div class="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <p class="text-sm md:text-base mb-6">{{ $t('services.psychological-services.parenting.description') }}</p>
            <ul class="space-y-3 text-sm md:text-base">
              <li class="flex items-center gap-2">
                <Icon name="mdi:check-circle" class="text-red-600 shrink-0" />
                {{ $t('services.psychological-services.parenting.understand') }}
              </li>
              <li class="flex items-center gap-2">
                <Icon name="mdi:check-circle" class="text-red-600 shrink-0" />
                {{ $t('services.psychological-services.parenting.communicate') }}
              </li>
              <li class="flex items-center gap-2">
                <Icon name="mdi:check-circle" class="text-red-600 shrink-0" />
                {{ $t('services.psychological-services.parenting.handle') }}
              </li>
              <li class="flex items-center gap-2">
                <Icon name="mdi:check-circle" class="text-red-600 shrink-0" />
                {{ $t('services.psychological-services.parenting.create') }}
              </li>
            </ul>
          </div>
          <!--<nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" src="/images/services/psychological-services-parenting.jpg"
            :alt="$t('services.psychological-services.parenting.title')" class="rounded-lg w-full h-64 object-cover" />-->
        </div>
      </div>

      <!-- Contact Section -->
      <div class="bg-gray-100 p-8 rounded-lg mt-16">
        <h2 class="text-xl md:text-2xl font-serif mb-4">{{ $t('services.psychological-services.contact.title') }}</h2>
        <p class="text-sm md:text-base text-gray-600 mb-8">
          {{ $t('services.psychological-services.contact.description') }}
        </p>
        <div class="flex flex-col md:flex-row gap-4">
          <NuxtLink :to="localePath('/contacts')">
            <Button class="bg-red-600 text-white px-6 py-3 w-full xl:w-auto">
              {{ $t('services.psychological-services.contact.book-btn') }}
            </Button>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>
